export interface LocalizationSource {
  [key: string]: string;
}

function localize(source: LocalizationSource, key: string): string {
  return key in source ? source[key] : key;
}

export default localize;
